var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"About-page-container"},[_c('div',{attrs:{"id":"about-section"}},[_c('h2',{attrs:{"id":"about-section-header"}},[_vm._v("About AHJ Registry")]),_c('h4',[_vm._v("Version 2.1.3")]),_c('h4',[_vm._v("Copyright 2023 SunSpec Alliance. All rights reserved.")])]),_c('hr')])
}]

export { render, staticRenderFns }